import { Box, type SxProps } from "@mui/material";
import NextImage, { type ImageProps as NextImageProps } from "next/image";

export interface ImageProps extends NextImageProps {
	sx?: SxProps;
}

export function Image({ sx, ...props }: Readonly<ImageProps>) {
	return (
		<Box
			sx={{
				position: "relative",
				lineHeight: 0,
				overflow: "hidden",
				width: "100%",
				...sx,
			}}
		>
			<NextImage
				{...props}
				style={{
					objectFit: "cover",
					height: "auto",
					width: "100%",
					...props.style,
				}}
			/>
		</Box>
	);
}
